export const GET_DRIVER_LOG = "GET_DRIVER_LOG";
export const GET_DRIVER_LOG_SUCCESS = "GET_DRIVER_LOG_SUCCESS";
export const GET_DRIVER_LOG_FAIL = "GET_DRIVER_LOG_FAIL";